import React, { useEffect } from "react";
import { Form, Input, Select, InputNumber } from 'antd';
import FormItem from "components/fields/FormItem";
import { connect } from "react-redux";
import { 
	getTrainingModuleDetails, doTrainingModuleCreate, doTrainingModuleUpdate 
} from "../../../../redux/trainingmodule/trainingModuleState";
import CrudButtons from "components/button/crudbuttons";
import { requiredField } from "utils/crudSagaHelper";
import { MODULE_TRAINING_MOD } from "variables/constants"
import TextArea from "antd/es/input/TextArea";

const TrainingModuleForm = ({
	recordData,
	getDetails,
	doCreate, 
	doUpdate, 
	onCancel,
	submitLabel,
	getRecord,
	...props
}) => {
	
  	const [form] = Form.useForm();
	const { recordId, mode } = props;  	

	useEffect(() => {
		if(recordId){
			getRecord(recordId);
		}
	}, [recordId, getRecord]);

	useEffect(() => {
		if (recordData) {
			form.resetFields();

			form.setFieldsValue({
				trm_id: recordData.trm_id,
				trm_title: recordData.trm_title,
				trm_description: recordData.trm_description,
				trm_question_items: recordData.trm_question_items,
				trm_passing_rate: Number(recordData.trm_passing_rate),
				trm_allowed_attempt: recordData.trm_allowed_attempt,
				trm_status_id: recordData.trm_status_id,
				trm_client_id: recordData.trm_client_id,
			});
		}
	}, [recordData]);

  	const onSubmit = (formData) => {	
    	try {  

			recordData.trm_id > 0 ? doUpdate(formData): doCreate(formData); 
    	} catch (error) {
      		console.error('Save failed:', error);
    	}
  	};
  
  	return (
    	<Form className="form"
			form={form} 
			layout="vertical"
			onFinish={onSubmit}
		>   
			<FormItem
				name="trm_id"
				hidden
			>
				<Input type="hidden"/>
			</FormItem>
			
			<div className="grid grid-cols-2 lg:grid-cols-4 gap-4">         		            	            
				<FormItem className="font-medium mb-2 col-span-2 lg:col-span-3"
					name="trm_title"
					label="Module Title"
					rules={[requiredField()]}
					
				>
					<Input id="trm_title"
						className="input-field"
						maxLength={100}
						placeholder="Enter training module title"
					/>
				</FormItem>	
				<FormItem 
					className="font-medium mb-2"
					name="trm_status_id"
					label="Status"
					rules={[requiredField()]}
				>
					<Select id="trm_status_id"
						className="input-field"
						showSearch
						allowClear={true}
						options={recordData?.trmStatusList}
					/>           
				</FormItem> 
				<FormItem 
					className="font-medium mb-2"
					name="trm_question_items"
					label="Question Items"
					rules={[requiredField()]}
				>
					<InputNumber
						id="trm_question_items"
						className="input-field w-full [&>input]:text-right"
						min={1}
						style={{ width: '100%', textAlign: 'right' }}
						placeholder="Number of questions"
					/>             
				</FormItem> 
				<FormItem 
					className="font-medium mb-2"
					name="trm_passing_rate"
					label="Passing Rate"
					rules={[requiredField()]}
				>
					<InputNumber
						id="trm_passing_rate"
						className="input-field"
						min={1}
						max={100}
						addonAfter="%"
						style={{ width: '100%' }}
						placeholder="Passing score"
					/>             
				</FormItem> 
				<FormItem 
					className="font-medium mb-2"
					name="trm_allowed_attempt"
					label=" Allowed Attempts "
					rules={[requiredField()]}
				>
					<InputNumber
						id="trm_allowed_attempt"
						className="input-field w-full [&>input]:text-right"
						min={1}
						style={{ width: '100%', textAlign: 'right' }}
						placeholder="Number of attempts"
					/>         
				</FormItem> 
				
				<FormItem
					className="font-medium mb-2 col-span-2 lg:col-span-1"
					label="Client"
					name="trm_client_id"
				>
					<Select id="trm_client_id"
						className="input-field"
						showSearch
						allowClear={true}
						options={recordData?.clientList}
					/>
				</FormItem>
				<FormItem 
					className="font-medium mb-2 col-span-2 lg:col-span-4"
					name="trm_description"
					label="Module Description"
					rules={[requiredField]}
					
				>
					<TextArea id="trm_description"
						className="input-field"
						maxLength={200}
						rows={3}
						placeholder="Enter training module description"
					/>
				</FormItem>	
			</div>


			<div className="w-full flex justify-end">
				{(mode === "edit") && (
					<CrudButtons
						mode={mode}
						recordId={recordData?.trm_id ?? 0}
						isModal={true}
						modalId={recordData?.trm_id > 0 ? 'edit_trainingModule' : 'add_trainingModule'}
						cancelLabel="Cancel"
						doHideModal={onCancel}
						submitLabel="Save Module"
						moduleId={MODULE_TRAINING_MOD}
					/>
				)}
			</div> 				 			
		</Form>	 	
  	);
};

const mapStateToProps = (state) => ({
  	recordData: state.trainingModule.trainingModuleDetails?.data,
});

const mapDispatchToProps = (dispatch) => ({
	getRecord: (id) => dispatch(getTrainingModuleDetails(id)),
  	doCreate: (data) => dispatch(doTrainingModuleCreate(data)),
  	doUpdate: (data) => dispatch(doTrainingModuleUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TrainingModuleForm);
